import { useNavigate } from "react-router-dom";
import { useContext, useEffect } from "react";
import AuthContext from "../contexts/auth-context";
import LocationsHeader from "./LocationsHeader";
import LocationsController from "./LocationsController";
import OfficeCard from "./Office/OfficeCard";
import EventCard from "./Event/EventCard";
import moment from "moment";

export default function Locations() {
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();

  // Check if session is valid
  const isSessionValid = authCtx.loggedIn &&
    moment.unix(authCtx.expirationTime) > moment(new Date());

  useEffect(() => {
    if (!isSessionValid) {
      navigate('/auth');
    }
  }, [isSessionValid, navigate]);

  // Show loading or nothing while redirecting
  if (!isSessionValid) {
    return null; // or a loading spinner
  }

  return (
    <LocationsController>
      {({ isLoading,
    offices,
    events,
    officeLocationData,
    eventLocationData,
    showOfficeSection,
    showEventSection,
    handleSearch,
    handleSort,
    refreshLocations,
    authCtx }) => (
        <div>
          {/* Header */}
          <LocationsHeader onSearch={handleSearch} onSort={handleSort} />
          
          {/* Main Content Area */}
          <div className="p-4">
          {isLoading ? (
            <div className="text-center">
              <span
                className="spinner-border spinner-border-lg"
                role="status"
                aria-hidden="true"
              />
            </div>
          ) : (
            <div className="row" style={{ display: 'flex', flexDirection: 'row' }}>
              {showOfficeSection && (
                <>
                  <div style={{ paddingLeft: '16px' }}>
                    <div style={{
                      fontSize: "1.5rem",
                      marginBottom: '16px',
                    }}>
                      Offices
                    </div>
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                      gap: '24px'
                    }}>
                      {offices.map((office) => (
                        <OfficeCard
                          key={office.id}
                          locationData={office}
                          data={officeLocationData[office.id] || { count: 0 }}
                        />
                      ))}
                    </div>
                  </div>
                </>
              )}
              {/* Events Section */}
              {showEventSection && (
                <>
                  {(showOfficeSection) && (
                    <hr style={{ marginTop: '24px' }} />
                  )}
                  <div style={{ paddingLeft: '16px', marginTop: '24px' }}>
                    <div style={{
                      fontSize: "1.5rem",
                      marginBottom: '16px',
                    }}>
                      Events
                    </div>
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                      gap: '24px'
                    }}>
                      {events.map((event) => (
                        <EventCard
                          key={event.id}
                          locationData={event}
                          data={eventLocationData[event.id] || {}}
                        />
                      ))}
                    </div>
                  </div>
                </>
              )}

            </div>
          )}
        </div>
        </div>
      )}
    </LocationsController>
  );
}